var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.036 3.189a1 1 0 0 0-1.931-.518l-.28 1.046a6.002 6.002 0 0 0-6.362 4.421L4.91 13.934l-1.583.914c-.772.445-.62 1.601.241 1.832l12.723 3.41c.86.23 1.57-.695 1.125-1.467L16.5 17.04l1.553-5.796a6.001 6.001 0 0 0-3.298-7.01l.28-1.045Zm-3.949 18.884a2 2 0 0 0 2.45-1.414l-3.864-1.035a2 2 0 0 0 1.414 2.449Z"
  })));
};
export default SvgNotifications;